import {AvatarPart, uid} from "../common";
import {hairColors} from "../colors";

const id = {
	mask1: uid("mask-"),
	mask3: uid("mask-"),
	path2: uid("path-"),
	path3: uid("path-"),
	path4: uid("path-"),
};

export default new AvatarPart({
	defs: [
		`<path
			id="${id.path3}"
			d="M156,180.610951 C173.530782,172.282984 186.048193,155.114792 187.791419,134.867187 C193.569129,134.002364 198,129.018625 198,123 L198,110 C198,104.054007 193.675427,99.1180731 188,98.1659169 L188,92 C188,61.072054 162.927946,36 132,36 C101.072054,36 76,61.072054 76,92 L76,92 L76,98.1659169 C70.3245733,99.1180731 66,104.054007 66,110 L66,123 C66,129.018625 70.4308707,134.002364 76.2085808,134.867187 C77.9518066,155.114792 90.4692178,172.282984 108,180.610951 L108,199 L104,199 L104,199 C64.235498,199 32,231.235498 32,271 L32,280 L232,280 L232,271 C232,231.235498 199.764502,199 160,199 L156,199 L156,180.610951 Z M0,5.68434189e-14 L264,5.68434189e-14 L264,280 L0,280 L0,5.68434189e-14 Z"
			/>
		<rect id="${id.path4}" x="0" y="0" width="112" height="150" rx="56"/>
		<mask id="${id.mask1}" fill="white">
			<use xlink:href="#${id.path4}"/>
		</mask>
		<mask id="${id.mask3}" fill="white">
			<use xlink:href="#${id.path3}"/>
		</mask>
		<path
			id="${id.path2}"
			d="M90.8779151,52.3613196 C113.02785,65.2272934 140.816672,65.2272934 174.244382,52.3613196 C188.77455,44.5891967 199.330608,29.0424257 182.951044,8.96303524 C180.782417,6.30455678 172.244382,15.6755614 155.351199,16.6504878 C138.458015,17.6254143 142.079654,13.3498661 124.102817,16.0739248 C106.12598,18.7979835 108.111968,33.37843 96.3814191,36.8768239 C84.6508698,40.3752178 86.5778198,49.8635735 90.8779151,52.3613196 Z"
			fill-rule="evenodd"/>`,
	],
	render ({color}) {
		return `
			<g  stroke-width="1" fill-rule="evenodd">
				<g mask="url(#frameMask})">
					<g transform="translate(-1.000000, 0.000000)">
						<g stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(1.000000, 0.000000)">
							<path
								d="M116.179148,40 L146,40 C171.405098,40 192,60.5949015 192,86 L192,154.108712 C192,180.650314 210.758775,204.349179 222.609956,226.05167 C234.461138,247.754161 215.254522,268.242596 195.770735,276.769484 C190.902336,278.900091 185.645645,280 180.331438,280 L135.26309,280 C78.9108161,280 70.2166412,216.309596 67.6972794,146.504423 L70.2166412,84.1431398 C71.212998,59.4805095 91.4964003,40 116.179148,40 Z"
								fill="${color}"
								mask="url(#${id.mask3})"/>
						</g>
						<g stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(77.000000, 36.000000)">
							<path
								mask="url(#${id.mask1})"
								fill-opacity="0.16"
								fill="#000000"
								d="M98.8014742,19.9396383 C107.026909,29.4843994 112,41.9114359 112,55.5 L112,65.5 L112,61.5 C112,45.7605792 105.327989,31.5794902 94.657974,21.6307409 C63.9198041,32.6768506 38.0141969,32.8027026 16.9411526,22.0082968 C6.50516181,31.936614 -1.90326939e-15,45.958626 0,61.5 L0,61.5 L0,65.5 L0,55.5 C-1.66642407e-15,41.8926148 4.98687681,29.4499771 13.2327229,19.8999944 C9.3991564,16.860899 8.25944611,8.18718262 19.4671989,4.87682391 C31.3115751,1.37843003 29.3063159,-13.2020165 47.4575903,-15.9260752 C65.6088648,-18.6501339 63.9714902,-11.3745857 81.028596,-12.3495122 C98.0857017,-13.3244386 103.635746,-29.1131795 106.849606,-25.0739991 C119.588767,-9.06341321 116.420993,9.34036319 98.8014742,19.9396383 Z"
								/>
						</g>
						<use fill="${color}" xlink:href="#${id.path2}"/>
						<use fill="#FFFFFF" fill-opacity="0.15" xlink:href="#${id.path2}"/>
					</g>
				</g>
			</g>
		`;
	},
	attrs: {
		color: hairColors,
	},
});



// WEBPACK FOOTER //
// ./src/top/long-hair-shaved-sides.js